import {
  List, Datagrid, TextField, BooleanField, EditButton, Edit, Create, SimpleForm,
  TextInput, BooleanInput, NumberInput, useEditContext, required,
} from 'react-admin';
import { Stack, Typography, Button as MuiButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import { ImageUploadInput } from '../../components/ImageUploadInput.jsx';

const AlbumList = () => (
  <List sort={{ field: 'sortOrder', order: 'ASC' }} perPage={25}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="title" />
      <TextField source="slug" />
      <BooleanField source="isPublished" label="Published" />
      <EditButton />
    </Datagrid>
  </List>
);

const AlbumForm = ({ isCreate }) => {
  const ctx = useEditContext();
  const id = ctx?.record?.id;
  return (
    <Stack spacing={2} sx={{ maxWidth: 720 }}>
      <TextInput source="title" validate={required()} fullWidth />
      <TextInput
        source="slug"
        helperText={isCreate ? 'Leave blank to auto-generate' : 'URL: /photos/' + (ctx?.record?.slug || '')}
        fullWidth
      />
      <TextInput source="description" multiline minRows={3} fullWidth />
      <ImageUploadInput source="coverImage" label="Cover image" />
      <Stack direction="row" spacing={2}>
        <BooleanInput source="isPublished" defaultValue={true} />
        <NumberInput source="sortOrder" defaultValue={0} />
      </Stack>
      {!isCreate && id && (
        <MuiButton
          component={RouterLink}
          to={`/gallery-images?filter=${encodeURIComponent(JSON.stringify({ albumId: id }))}`}
          variant="outlined"
          size="small"
          sx={{ alignSelf: 'flex-start' }}
        >
          Manage images in this album →
        </MuiButton>
      )}
    </Stack>
  );
};

const AlbumEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><AlbumForm /></SimpleForm>
  </Edit>
);
const AlbumCreate = () => (
  <Create redirect="list">
    <SimpleForm><AlbumForm isCreate /></SimpleForm>
  </Create>
);

export default {
  list: AlbumList,
  edit: AlbumEdit,
  create: AlbumCreate,
  icon: PhotoLibraryIcon,
  options: { label: 'Gallery albums' },
  recordRepresentation: 'title',
};
